import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import addressBookReducer from './slices/addressBookSlice';
import bookingReducer from './slices/bookingSlice';
import apiReducer from './slices/apiSlice';
import userProfileReducer from './slices/userProfileSlice';
import shipmentTemplatesReducer from './slices/shipmentTemplatesSlice';

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  addressBook: addressBookReducer,
  booking: bookingReducer,
  api: apiReducer,
  userProfile: userProfileReducer,
  shipmentTemplates: shipmentTemplatesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Logger middleware for Redux (development only)
const logger = (store) => (next) => (action) => {
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    // Enable for debugging: console.log('[Redux Action]', action);
  }
  return next(action);
};

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(logger),
});

export const persistor = persistStore(store);
export default store;
